<template>
    <div class="dayEvent" :style="{ top: `${eventTop}px`, height: `${eventHeight}px`, left: `${eventLeft}`, width:
        `${eventWidth}` }" @click="$emit('click', $event)">
        <div class="time" v-if="eventHeight>20">{{startTime}}</div>
        <div class="summary">{{event.summary}}</div>
    </div>
</template>

<script>
import { DateTime } from 'luxon';
import cssVars from '@/assets/bootstrap-style.scss';

export default {
  name: 'calendarDayEvent',
  props: {
    event: Object
  },
  computed: {
    startTime() {
      return this.event.startDateTime.toLocaleString(DateTime.TIME_24_SIMPLE);
    },
    startMinute() {
      return this.event.startDateTime.hour * 60 + this.event.startDateTime.minute;
    },
    endMinute() {
      return this.event.endDateTime.hour * 60 + this.event.endDateTime.minute;
    },
    eventTop() {
      return this.startMinute * this.rowHeight / 30;
    },
    eventHeight() {
      return (this.endMinute - this.startMinute) * this.rowHeight / 30;
    },
    eventLeft() {
      return `calc((100% - 2px) / ${this.event.displayColumnCount} * ${this.event.displayColumn} + 2px)`;
      // ${(100 / this.event.displayColumnCount) * this.event.displayColumn;
    },
    eventWidth() {
      return `calc((100% / ${this.event.displayColumnCount} - 4px)`;
    },
    rowHeight() {
      return parseInt(cssVars.calendarDayRow, 10);
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .dayEvent {
        position: absolute;
        background-color: $calendar-event-background;
        border: $calendar-event-border;
        border-left: $calendar-event-border-left;
        left: 2px;
        width: 100%;
        z-index: 100;
        font-size: 0.7rem;
        min-height: 1rem;
        cursor: pointer;
        overflow: hidden;
    }
</style>
